import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/content";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { VideoSection } from "@/components/site/VideoSection";
import { HowTo } from "@/components/site/HowTo";
import { SignupSection } from "@/components/site/SignupSection";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    api
      .get("/content")
      .then(({ data }) => setContent({ ...DEFAULT_CONTENT, ...data }))
      .catch(() => {});
  }, []);

  const scrollToSignup = () => {
    const el = document.getElementById("signup");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="landing-page">
      <Nav onSignUp={scrollToSignup} c={content} />
      <Hero onSignUp={scrollToSignup} c={content} />
      <Ribbon c={content} />
      <Manifesto c={content} />
      <VideoSection c={content} />
      <HowTo c={content} onSignUp={scrollToSignup} />
      <SignupSection c={content} />
      <Footer c={content} />
    </div>
  );
}
